import React from "react";
import { Box, Typography, Grid, Container, useTheme } from "@mui/material";

const steps = [
    {
        title: "Mission",
        subtitle: "Smarter saving. Better earning. Future-ready",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mission?updatedAt=1756998051532",
    },
    {
        title: "Vision",
        subtitle: "Your family’s money. One smart app",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/vision?updatedAt=1756998051643",
    },
    {
        title: "Value",
        subtitle: "Grow your wealth smartly",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/value?updatedAt=1756998051635",
    },
];

const MissionCard = ({ title, subtitle, image }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                p: { xs: 3, md: 4 },
                borderRadius: "20px",
                width: "100%",
                background: `linear-gradient(
            180deg,
            #ffffff,
            ${theme.palette.secondary.main}
        )`,
                boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                transition: "all 0.4s ease",
                position: "relative",
                cursor: "pointer",
                overflow: "hidden",

                "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: `0 30px 70px ${theme.palette.primary.main}30`,
                },

                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: "20px",
                    padding: "1.5px",
                    background: `linear-gradient(135deg, ${theme.palette.primary.main}, transparent 70%)`,
                    WebkitMask:
                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                    WebkitMaskComposite: "xor",
                    maskComposite: "exclude",
                    opacity: 0,
                    transition: "opacity 0.35s ease",
                },

                "&:hover::before": {
                    opacity: 1,
                },
            }}
        >

            <Box
                component="img"
                src={image}
                alt={title}
                sx={{
                    width: 52,
                    height: 52,
                    mb: 2,
                }}
            />

            <Typography
                sx={{
                    fontWeight: 800,
                    fontSize: 15,
                    color: theme.palette.primary.main,
                    mb: 1,
                }}
            >
                {title}
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    fontSize: 13,
                    color: "#555",
                    lineHeight: 1.7,
                }}
            >
                {subtitle}
            </Typography>
        </Box>
    );
};

const Mission = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                py: { xs: 4, md: 2 },
                px: { xs: 2, md: 0 },
            }}
        >



            <Typography
                sx={{
                    fontSize: { xs: "20px", sm: "28px", md: "40px" },
                    fontWeight: 600,
                    textAlign: "center",
                    lineHeight: 1.1,
                    mb: 3,
                    animation: "fadeUp 0.9s ease-out both",
                    color: theme.palette.text.primary,
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                }}
            >
                Our{" "}
                <Box
                    component="span"
                    sx={{
                        fontWeight: 900,
                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "-4px",
                            left: 0,
                            width: "100%",
                            height: "2px",
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                        }
                    }}
                >
                    mission
                </Box>{" "}
            </Typography>

            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="center">
                    {steps.map((step, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MissionCard {...step} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Mission;
